import { axios, getConfigs, IRequestConfig, IRequestOptions } from './api'

export interface CreateRequestingOrganisationDto {
  name: string
  address: string
  zipCode: string
  city: string
  siret?: string | null
  billingEmail?: string | null
  chorusEnabled?: boolean
  chorusServiceCode?: string | null
  chorusEngagementNumber?: string | null
  siteId: number
}
export interface RequestingOrganisationDto {
  id: string
  name: string
  address: string
  zipCode: string
  city: string
  siret: string | null
  billingEmail: string | null
  chorusEnabled: boolean
  chorusServiceCode: string | null
  chorusEngagementNumber: string | null
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  siteId?: number
  site?: { id: number; label: string }
}

export class RequestingOrganisationService {
  private static basePath = '/requesting-organisations'
  static findAll(
    params: {
      search?: string
      siteId?: number
      page?: number
      limit?: number
      order?: 'asc' | 'desc'
      sortBy?: string
    } = {} as any,
    options: IRequestOptions = {},
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        this.basePath,
        options,
      )
      configs.params = params
      configs.data = null
      axios(configs, resolve, reject)
    })
  }

  static create(
    params: { body?: CreateRequestingOrganisationDto } = {} as any,
    options: IRequestOptions = {},
  ): Promise<RequestingOrganisationDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'post',
        'application/json',
        this.basePath,
        options,
      )
      configs.data = params.body
      axios(configs, resolve, reject)
    })
  }

  static update(
    params: {
      id: string
      body?: Partial<CreateRequestingOrganisationDto>
    } = {} as any,
    options: IRequestOptions = {},
  ): Promise<RequestingOrganisationDto> {
    return new Promise((resolve, reject) => {
      let url = this.basePath + '/{id}'
      url = url.replace('{id}', params['id'] + '')
      const configs: IRequestConfig = getConfigs(
        'patch',
        'application/json',
        url,
        options,
      )
      configs.data = params.body
      axios(configs, resolve, reject)
    })
  }

  static remove(
    params: { ids: string[] } = {} as any,
    options: IRequestOptions = {},
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'delete',
        'application/json',
        this.basePath,
        options,
      )
      configs.data = { ids: params.ids }
      axios(configs, resolve, reject)
    })
  }
}
